import type { SessionUser } from "../../../../../shared/auth/access";
import { useRequestDetailData } from "./useRequestDetailData";
import { useRequestDecisionWorkspace } from "./useRequestDecisionWorkspace";
import { useRequestEditWorkspace } from "./useRequestEditWorkspace";
import { useRequestOffersWorkspace } from "./useRequestOffersWorkspace";
import { useRequestAttachmentsWorkspace } from "./useRequestAttachmentsWorkspace";

type Options = {requestNo: string; user: SessionUser; notify: (message: string) => void; onRequestRoutedForApproval?: () => void};
export function useRequestDetailWorkspace(options: Options) {
  const data = useRequestDetailData(options);
  const decision = useRequestDecisionWorkspace({...data, onRequestRoutedForApproval: options.onRequestRoutedForApproval});
  const edit = useRequestEditWorkspace(data);
  const offers = useRequestOffersWorkspace({...options, ...data});
  const attachments = useRequestAttachmentsWorkspace({requestNo: options.requestNo, scope: data.scope});
  return {...data, ...decision, ...edit, ...offers, ...attachments, scope: data.scope};
}
